import type { BrokerAccountView } from "./models.js";

interface AccountSelectorProps {
  readonly accounts: readonly BrokerAccountView[];
  readonly id?: string;
  readonly onChange: (accountId: string) => void;
  readonly value: string;
}

export function AccountSelector({
  accounts,
  id = "broker-account",
  onChange,
  value,
}: AccountSelectorProps) {
  const readyAccounts = accounts.filter((account) => account.status === "ready");
  return (
    <div className="field-stack">
      <label htmlFor={id}>Tastytrade account</label>
      <select id={id} value={value} onChange={(event) => onChange(event.currentTarget.value)}>
        <option value="">All ready accounts</option>
        {readyAccounts.map((account) => (
          <option key={account.id} value={account.id}>
            {account.displayName}
          </option>
        ))}
      </select>
      {readyAccounts.length === 0 ? (
        <span className="field-hint">Reconnect Tastytrade to discover ready accounts.</span>
      ) : null}
    </div>
  );
}
